import { ColumnDirective, ColumnsDirective, GridComponent, Inject, Page, Sort } from "@syncfusion/ej2-react-grids";
import { cashnator, formatarData } from "../utils/functions";

const TransactionsList = ({ transactions, setEdit, setEditableTransaction }) => {

    const handleEdit = (transaction) => {
        setEdit(true);
        setEditableTransaction(transaction);
    }

    return (
        <GridComponent dataSource={transactions} allowSorting allowPaging pageSettings={{ pageSize: 30 }}>
            <ColumnsDirective>
                <ColumnDirective field='product._id' headerText="ID Pedido" width='200' textAlign="Center" />
                <ColumnDirective field='product.finalPrice' width='100' headerText="Valor" textAlign="Center" valueAccessor={(f, d) => { return cashnator(d?.product?.finalPrice) }} />
                <ColumnDirective field='user.email' width='100' headerText="Usuário" textAlign="Center" />
                <ColumnDirective field='data.status' width='100' headerText="Status" textAlign="Center" />
                <ColumnDirective field='data.received_at' width='100' headerText="Data" textAlign="Center" valueAccessor={(f, d) => { return formatarData(d?.data?.received_at) }} />
                <ColumnDirective width='100' textAlign="Center" template={(d, f) => { return <button onClick={() => handleEdit(d)} className="bg-blue-500 hover:bg-blue-800 px-2 text-black">Ver</button> }} />
            </ColumnsDirective>
            <Inject services={[Sort, Page]} />
        </GridComponent>
    )
}

export default TransactionsList;
